'use client'

import { Builder, BuilderComponent } from '@builder.io/react'
import { nextTick } from '@patrianna/shared-utils'
import { useRouter } from 'next/navigation'

import type { BuilderContent } from 'app/utils/builder'

import classes from './styles.module.scss'

type Props = {
  content: BuilderContent | null
  model: string
}

function BuilderTextContent({ content, model }: Props) {
  const router = useRouter()

  const handleLinkClick = (e: any) => {
    nextTick().then(() => {
      if (e.target.closest('a') && e.target.closest('a').attributes.target?.value !== '_blank') {
        e.preventDefault()
        const url = e.target.closest('a').attributes.href.value
        router.push(url)
      }
    })
  }

  return (
    <div className={classes.root} onClick={handleLinkClick}>
      {content || Builder.isPreviewing ? <BuilderComponent content={content} model={model} /> : <h1>404</h1>}
    </div>
  )
}

export default BuilderTextContent
